import styled from 'styled-components';

export const LoadingContainer = styled.div`
  background-color: rgba(145, 132, 115, 0.3);
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  object-fit: cover;
  position: relative;
  min-height: 100vh;
  max-width: 100%;
  align-items: center;
  text-align: center;
`;
